(function CruiseSheets($, Adzuki)
{
	"use strict";

	var CruiseSheets = {};

	/**
	 * Clear out the value of any input with a class of .pricing-field that is within a .table-row that also contains the $checkbox being passed in
	 * @param  jQuery object $checkbox checkbox in the .table-row
	 */
	CruiseSheets.clearPricingFields = function clearPricingFields($checkbox) {
		var $parent_row = $checkbox.closest('.table-row');
		$parent_row.find('.pricing-field').val('');
	};

	$(document).ready(function documentReady()
	{
		var pages = [
			'CruiseSheets/prepare',
			'CruiseSheets/edit',
			'CruiseSheets/duplicate',
			'CruiseSheets/details',
		];

		var excursion_pages = [
			'CruiseSheets/edit',
			'CruiseSheets/details'
		];

		Adzuki.onload(excursion_pages, function onload() {
			// "Include Excursions" checkbox changed
			$('.allow-excursions').on('change', function includeExcursions(e) {
				var $self   = $(this),
				    $divs   = $('.specific-excursion'),
				    $counts = $('.specific-excursion .counts');

				if ($self.prop('checked') === false) {
					$divs.addClass('hidden');
					$('.selected_excursions').val('');

				} else {
					$divs.removeClass('hidden');
				}

				// clear count indications showing outside of modal
				$counts.html('');
			});
		});

		Adzuki.onload('CruiseSheets/sent', function onload() {
			$("#cruise_sheet_filter_criteria .remove").click(function removeCriteriaSent(event) {
				removeFilterCriteria('sent', $(this));
			});
		});

		Adzuki.onload('CruiseSheets/multiple', function onload() {
			$("#cruise_sheet_bundle_filter_criteria .remove").click(function removeCriteriaMultiple(event) {
				removeFilterCriteria('multiple', $(this));
			});
		});

		Adzuki.onload('CruiseSheets/index', function onload() {
			// adjust the max number of steps in the header
			$("#cruisesheetbuild-add_multiple").change(function addMultiple(event) {
				var $self      = $(this),
				    $header    = $('#cruise-sheet-create-header').find('h3'),
				    header_txt = $header.html();

				if ($self.val() === '0') {
					$header.html(header_txt.replace('4', '3'));
				} else {
					$header.html(header_txt.replace('3', '4'));
				}
			});
		});

		Adzuki.onload(pages, function onload() {

			// if "Display as Single Page" is checked, do not allow them to include ShoreTrips
			$(".single-page-display").click(function singlePage(event) {
				var $self              = $(this),
				    $parent            = $self.closest('.cruise-sheet-information'),
				    $shoretrips        = $parent.find('.allow-excursions'),
				    $destination_guide = $parent.find('.destination-guides');

				if ($self.is(':checked')) {
					$shoretrips.prop('checked', false).trigger('change');
					$destination_guide.prop('checked', false);

					$shoretrips.prop('disabled', true);
					$destination_guide.prop('disabled', true);

					$('#cruise-sheet-attachments').hide();

				} else {
					$shoretrips.prop('disabled', false);
					$destination_guide.prop('disabled', false);

					$('#cruise-sheet-attachments').show();
				}
			});
		}, false);

		Adzuki.onload('CruiseSheets/edit', function onload() {
			window.addEventListener("message", receivedMessage, false);
		}, false);
	});

	function receivedMessage(event)
	{
		var pricing_method  = $('#cruisesheetprepare-pricing_method').val(),
		    cruise_sheet_id = $('#cruisesheetprepare-id').val(),
		    $container,
		    cached;

		// only interested after "finished" posted
		if (event.data !== 'finished') {
			return false;
		}

		if (pricing_method === 'econnect') {
			$container = $('#live-pricing .details');
			cached     = $container.data('cached');

			// we need to replace the loading animation with the most recent live pricing info
			if (cached === 0) {
				Adzuki.Ajax.get('/CruiseSheets/getLivePricing/' + cruise_sheet_id)
				.then(function populate(content) {
					$container.html(content);
				});
			}
		}
	}

	function removeFilterCriteria(action, $el)
	{
		var filter_key   = $el.data('filter-key'),
		    filter_value = $el.data('filter-value'),
		    url          = Adzuki.base_uri + '/CruiseSheets/removeFilterCriteria/' + action + '/' + filter_key;

		if (filter_value !== undefined) {
			url += '/' + filter_value;
		}
		window.location.href = url;
	}

	// if the user forgets to check a row, but just enters a value greater than zero in one of the pricing fields, go ahead and check that category
	$('.cruise-sheet-form').on('change', '.pricing-field', function fieldChange() {
		var $self         = $(this),
		    $parent_row   = $self.closest('.table-row'),
		    $checkbox     = $parent_row.find('.ship-category-check');

		if ($self.val() > 0) {
			$checkbox.prop('checked', true);
		}
	});

	// clear pricing fields if user turns off a ship category
	$('.cruise-sheet-form').on('click', '.ship-category-check', function fieldChange() {
		var $self = $(this);
		if (!$self.prop('checked')) {
			Adzuki.CruiseSheets.clearPricingFields($self);
		}
	});

	Adzuki.CruiseSheets = CruiseSheets;

}(jQuery, window.Adzuki || {}));
